import React from "react";
import { NavLink } from "react-router-dom";
import { getMenuItems } from "../utils/menuItems";
import { useAuth } from "../context/AuthContext";

function RoleSidebar() {
    const { user } = useAuth();
    const userRole = user?.role || "guest";

    // Get the correct menu items based on user role
    const items = getMenuItems(userRole, user?.permissions);

    return (
        <div className="fixed top-0 left-0 z-50 w-56 h-screen text-white bg-gray-900 shadow-lg ">
            {/* Sidebar logo */}
            <div className="flex items-center justify-center h-16 text-lg font-bold tracking-widest text-white bg-primary">
                {userRole === "admin" ? "ADMIN PORTAL" : "STOJALITICS"}
            </div>

            <div className="flex flex-col flex-1 mt-4 overflow-y-auto">
                {items.map((item, index) => (
                    <NavLink
                        key={index}
                        to={item.path}
                        className={({ isActive }) =>
                            `flex items-center gap-4 px-4 py-3 rounded-lg mx-2 transition-all duration-200 hover:bg-gray-700 ${
                                isActive
                                    ? "bg-primary text-white font-bold"
                                    : "text-gray-300"
                            }`
                        }
                    >
                        <span className="flex items-center justify-center w-6 text-xl">
                            {item.icon}
                        </span>
                        <span className="whitespace-nowrap">{item.label}</span>
                    </NavLink>
                ))}
            </div>

            {/* User role indicator */}
            <div className="flex items-center justify-between px-4 py-3 text-sm text-gray-500">
                <span>&copy; 2024 STOJALITICS</span>
                <span className="px-2 py-1 text-xs bg-gray-800 rounded">
                    {userRole.toUpperCase()}
                </span>
            </div>
        </div>
    );
}

export default RoleSidebar;
